import { types, getParent, flow } from 'mobx-state-tree';
import _ from 'lodash';
import moment from 'moment';
import { filtersByGroupsScheme, getInitialFilterValues, initialSourceMarketPlaces } from './utils';
import Account from '../../models/Account';
import { SellerAccountsSelection, StatusSelect, FilterActions } from '../common';
import { statusList } from '../../constants/orders/status-list';
import { formatDate } from '../../utils/format-date';
import MarketPlace from '../../models/MarketPlace';
import { SourceMarketPlaceSelect } from '../common/SourceMarketPlaceSelect';

const FilterValues = types.compose(
  types
    .model('FilterValues', {
      statuses: types.optional(types.array(types.string), []),
      sourceMarketPlaces: types.optional(types.array(MarketPlace), []),
      sourceMarketPlaceIds: types.optional(types.array(types.string), []),
      failedReason: types.string,
      buyerOrderDateFrom: types.string,
      buyerOrderDateTo: types.string,
      selectedSellerAccounts: types.optional(types.array(types.reference(Account)), []),
      destinationPriceFrom: types.string,
      destinationPriceTo: types.string,
      profitFrom: types.string,
      profitTo: types.string,
      estimatedShippingTimeFrom: types.string,
      estimatedShippingTimeTo: types.string,
      ebayGlobalShippingProgram: types.maybe(types.boolean),
      lateShipment: types.maybe(types.boolean),
    })
    .views(self => ({
      get initialFilterValues() {
        return getInitialFilterValues();
      },
      get failedReasonsList() {
        return getParent(self).failedReasons;
      },
      get statusesObj() {
        return _.keyBy(self.statuses, s => s);
      },
      get orderStatusesObj() {
        return _.keyBy(self.statuses, s => s);
      },
      get statusList() {
        return statusList;
      },
      get scheme() {
        return filtersByGroupsScheme;
      },
      get transport5007() {
        return getParent(self).transport5007;
      },
      get isBetaUser() {
        return getParent(self).isBetaUser;
      },
      get defaultCurrencyId() {
        return 'USD'; // getParent(self).settingsStore.userProfile.defaultCurrencyId;
      },
      get sourceMarketPlacesObj() {
        return _.keyBy(self.sourceMarketPlaceIds, s => s);
      },
    }))
    .actions(self => ({
      setOrderStatus(status) {
        self.orderStatus = status;
      },
      setFailedReason(reason) {
        self.failedReason = reason;
      },
      setBuyerOrderDateFrom(e) {
        if (e.target.value && moment(e.target.value).isBefore(moment())) {
          self.buyerOrderDateFrom = formatDate(e.target.value);
        } else if (e.target.value === '') {
          self.buyerOrderDateFrom = '';
        }
      },
      setBuyerOrderDateTo(e) {
        if (e.target.value && moment(e.target.value).isBefore(moment())) {
          self.buyerOrderDateTo = formatDate(e.target.value);
        } else if (e.target.value === '') {
          self.buyerOrderDateTo = '';
        }
      },
      setDestinationPriceFrom(e) {
        self.destinationPriceFrom = e.target.value;
      },
      setDestinationPriceTo(e) {
        self.destinationPriceTo = e.target.value;
      },
      setProfitFrom(e) {
        self.profitFrom = e.target.value;
      },
      setProfitTo(e) {
        self.profitTo = e.target.value;
      },
      setEstimatedShippingTimeFrom(e) {
        self.estimatedShippingTimeFrom = e.target.value;
      },
      setEstimatedShippingTimeTo(e) {
        self.estimatedShippingTimeTo = e.target.value;
      },
      setGlobalShippingProgramm(e) {
        self.ebayGlobalShippingProgram = e.target.checked;
      },
      setLateShipment(e) {
        self.lateShipment = e.target.checked;
      },
      setSourceMarketplaces() {
        initialSourceMarketPlaces;
        self.sourceMarketPlaces = self.isBetaUser
          ? initialSourceMarketPlaces
          : initialSourceMarketPlaces.filter(market => !market.id.includes('CJ'));
      },
      fetchSourceMarketPlaces: flow(function* fetchSourceMarketPlaces() {
        try {
          const { data } = yield self.transport5007.fetch(
            `account/v1/source-marketplaces?currency=${self.defaultCurrencyId}`,
          );
          self.sourceMarketPlaces = self.isBetaUser
            ? data
            : data.filter(market => !market.id.includes('CJ'));
        } catch (err) {
          console.log('Could not get the source market places ', err);
        } finally {
          console.log('Finished getting source market places');
        }
      }),
    })),
  SellerAccountsSelection,
  StatusSelect,
  FilterActions,
  SourceMarketPlaceSelect,
);

export default FilterValues;
